import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useLocation } from 'react-router-dom';

import {
  setNamePage,
  getPage,
  getCount,
  getCorectyName,
  increment,
  decrement,
  cleanCount,
} from '../../redux/slices/backHistorySlice';
import './style.scss';

const HistoryButton = ({ user }) => {
  const currentLocation = useLocation();

  const locationName =
    useLocation().pathname == '/'
      ? useLocation().pathname.split('/').join('') + 'home'
      : useLocation().pathname.split('/').join('');
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const namePgae = useSelector(getPage);
  const count = useSelector(getCount);
  const corectlyNamePage = useSelector(getCorectyName);

  if (!JSON.parse(sessionStorage.getItem('history'))) {
    sessionStorage.setItem('history', JSON.stringify({ count: 0, prevPageArray: ['home'] }));
  }
  const historyStorage = JSON.parse(sessionStorage.getItem('history'));

  useEffect(() => {
    dispatch(setNamePage(locationName));

    dispatch(increment());

    const historyArr = historyStorage.prevPageArray;
    const historyCount = historyStorage.count;

    if (historyArr[historyArr.length - 1] !== String(locationName)) {
      historyArr.push(String(locationName));
      sessionStorage.setItem('history', JSON.stringify({ count: historyCount + 1, prevPageArray: historyArr }));
    } else {
      sessionStorage.setItem('history', JSON.stringify({ count: historyCount, prevPageArray: historyArr }));
    }

    if (currentLocation.pathname == '/' && !user) {
      dispatch(cleanCount());
    }
  }, [locationName, user]);

  const onClickBack = () => {
    if (count > 1) {
      dispatch(decrement());

      const historyArr = historyStorage.prevPageArray;
      const historyCount = historyStorage.count;

      sessionStorage.setItem('history', JSON.stringify({ count: historyCount - 2, prevPageArray: historyArr }));

      navigate(-1);
    }
  };

  return (
    <>
      {count > 1 && (
        <button className="button-back-history" onClick={onClickBack}>
          <span className="icon-ArrowUp-left"></span>
          {/* <span className="text text-left">Назад </span> */}
          {/* <span className="text text-right"> {corectlyNamePage}</span> */}
        </button>
      )}
    </>
  );
};

export default HistoryButton;
